"use client";

import React, { useState } from "react";

export const programsByTab = {
  health_science: [
    {
      program: "Diploma in Emergency Medical Technologist",
      duration: "2.5 Years",
      eligibility: "10+2 (Any Stream) with 50% Aggregate",
    },
    {
      program: "Bachelor of Emergency Medical Technologist",
      duration: "4 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "M.Sc. in Advanced Care Paramedic",
      duration: "2 Years",
      eligibility:
        "B.Sc. in Critical Care Technology/Anesthesia & Critical Care Technology/Bachelor in Emergency Medical Technology",
    },
    {
      program: "Diploma in Dialysis Therapy Technology",
      duration: "2.5 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "Bachelor of Dialysis Therapy Technology",
      duration: "4 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "M.Sc. in Dialysis Therapy",
      duration: "2 Years",
      eligibility: "B.Sc. in Dialysis Technology",
    },
    {
      program: "Diploma in Medical Laboratory Science",
      duration: "2.5 Years",
      eligibility: "10+2 (Any Stream) with 50% Aggregate",
    },
    {
      program: "Bachelor of Medical Laboratory Science",
      duration: "4 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "M.Sc. in Medical Laboratory Science",
      duration: "2 Years",
      eligibility:
        "B.Sc. in Medical Laboratory Technology/Medical Laboratory Sciences",
    },
    {
      program: "Diploma in Medical Radiology & Imaging Technology",
      duration: "2.5 Years",
      eligibility: "10+2 (Any Stream) with 50% Aggregate",
    },
    {
      program: "Bachelor of Medical Radiology & Imaging Technology",
      duration: "4 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "M.Sc. in Medical Radiology & Imaging Technology",
      duration: "2 Years",
      eligibility:
        "Bachelor's in Medical Radiology & Imaging Technology/Medical Technology Radio diagnosis and Imaging/Radiological Technology/Radiography/Medical Technology (X-ray) or equivalent to BMRIT with 60% marks in Bachelor's",
    },
    {
      program: "Diploma in Anesthesia & Operation Theatre Technology",
      duration: "2.5 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "Bachelor of Anesthesia & Operation Theatre Technology",
      duration: "4 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "M.Sc. in Anesthesia & Operation Theatre Technology",
      duration: "2 Years",
      eligibility:
        "B.Sc. in Anaesthesia & Operation Theatre Technology/Anaesthesia Technology/Operation Theatre Technology",
    },
    {
      program: "Bachelor of Optometry (B.Opto.)",
      duration: "5 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "Masters of Optometry",
      duration: "2 Years",
      eligibility: "Bachelor of Optometry",
    },
    {
      program: "Bachelor of Physiotherapy (BPT)",
      duration: "5 Years",
      eligibility: "10+2 (Science with Biology) with 50% Aggregate",
    },
    {
      program: "Bachelor of Hospital Administration",
      duration: "4 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "M.Sc. in Clinical Microbiology",
      duration: "2 Years",
      eligibility:
        "Graduation in Biotechnology/Zoology/Botany/Microbiology",
    },
  ],

  computer_science: [
    {
      program: "Diploma in Computer Science Engineering",
      duration: "3 Years",
      eligibility: "10th Qualified",
    },
    {
      program: "BCA in Full-Stack Development & Cloud Integration",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "BCA in Software Development",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program:
        "B.Tech in Computer Science & Engineering (Artificial Intelligence & Machine Learning)",
      duration: "4 Years",
      eligibility: "10+2 (With Physics, Chemistry & Mathematics)",
    },
    {
      program:
        "B.Tech in Computer Science & Engineering (Cloud Computing & Cybersecurity)",
      duration: "4 Years",
      eligibility: "10+2 (With Physics, Chemistry & Mathematics)",
    },
    {
      program: "MCA in Data Analytics",
      duration: "2 Years",
      eligibility:
        "Graduate (Any Stream) (With Mathematics in 10/12/Graduation)",
    },
    {
      program: "MCA in Cyber Security",
      duration: "2 Years",
      eligibility:
        "Graduate (Any Stream) (With Mathematics in 10/12/Graduation)",
    },
  ],

  management_commerce: [
    {
      program: "BBA in Business Management",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "B.Com in Professional Accounting",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "M.Com in Professional Accounting",
      duration: "2 Years",
      eligibility: "Graduate with B.Com",
    },
    {
      program: "MBA in Strategic Marketing",
      duration: "2 Years",
      eligibility: "Graduate (Any Stream)",
    },
    {
      program: "MBA in Business Finance",
      duration: "2 Years",
      eligibility: "Graduate (Any Stream)",
    },
    {
      program: "MBA in Tech HR",
      duration: "2 Years",
      eligibility: "Graduate (Any Stream)",
    },
  ],

  hospitality_tourism: [
    {
      program: "B.Sc. in Hospitality & Hotel Management",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "Professional Diploma in Hospitality & Hotel Management",
      duration: "1 Year",
      eligibility: "10+2 (Any Stream)",
    },
  ],

  humanities: [
    {
      program: "B.A. in Applied English",
      duration: "3 Years",
      eligibility: "10+2 (Any Stream)",
    },
    {
      program: "M.A. in Applied English",
      duration: "2 Years",
      eligibility: "Graduate (Any Stream)",
    },
  ],

  nursing: [
    {
      program: "B.Sc. in Nursing",
      duration: "4 Years",
      eligibility: "10+2 (Science)",
    },
  ],

  pharmacy: [
    {
      program: "Bachelor of Pharmacy (B.Pharm)",
      duration: "4 Years",
      eligibility: "10+2 (Science)",
    },
    {
      program: "Diploma in Pharmacy (D.Pharm)",
      duration: "2 Years",
      eligibility: "10+2 (Science)",
    },
  ],
};

export const tabList = [
  { id: "health_science", label: "School of Health Science & Technology" },
  { id: "computer_science", label: "School of Computer Science & Engineering" },
  { id: "management_commerce", label: "School of Management & Commerce" },
  { id: "hospitality_tourism", label: "School of Hospitality & Tourism" },
  { id: "humanities", label: "School of Humanities" },
  { id: "nursing", label: "College of Nursing" },
  { id: "pharmacy", label: "School of Pharmacy" },
];

const ProgramsSection = () => {
  const [activeTab, setActiveTab] = useState(tabList[0].id);
  const rows = programsByTab[activeTab] || [];

  return (
    <section className="w-full bg-white mt-7">
      <div className="grid grid-cols-1 md:grid-cols-[minmax(0,0.9fr)_minmax(0,2fr)] gap-6 md:gap-8">

        <div className="">
          <div
            className="
              sticky
              top-0
              md:top-24
              bg-white/95
              md:bg-transparent
              z-20
              pb-3
              md:pb-0
            "
          >
            <div className="md:flex md:flex-col md:gap-3">
              {/* Mobile: horizontal scroll list */}
              <div className="flex md:hidden gap-3 overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-slate-300 scrollbar-track-slate-100 pr-2">
                {tabList.map((tab) => {
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex-shrink-0 min-w-[220px] flex items-center justify-between border px-4 py-3 text-xs sm:text-sm transition-all
                        ${
                          isActive
                            ? "border-[#00304b] bg-white shadow-[0_8px_20px_rgba(0,48,75,0.18)]"
                            : "border-slate-200 bg-white hover:bg-slate-50"
                        }
                      `}
                      style={{ fontFamily: "saans-bold" }}
                    >
                      <span className="text-slate-800">{tab.label}</span>
                      <span className={`text-lg leading-none ${isActive ? "text-[#00304b]" : "text-slate-500"}`}>
                        {isActive ? "-" : "+"}
                      </span>
                    </button>
                  );
                })}
              </div>

              {/* Desktop: vertical stack like screenshot */}
              <div className="hidden md:flex md:flex-col md:gap-3">
                {tabList.map((tab) => {
                  const isActive = activeTab === tab.id;
                  return (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      className={`flex items-center justify-between cursor-pointer border px-4 py-4 text-sm transition-all text-left
                        ${
                          isActive
                            ? "border-[#00304b] bg-white shadow-[0_10px_25px_rgba(0,48,75,0.20)] translate-y-[-1px]"
                            : "border-slate-200 bg-white hover:bg-slate-50"
                        }
                      `}
                      style={{ fontFamily: "saans-bold" }}
                    >
                      <span className="text-slate-800">{tab.label}</span>
                      <span className={`text-lg leading-none ${isActive ? "text-[#00304b]" : "text-slate-500"}`}>
                        {isActive ? "-" : "+"}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Table with sticky header, nicer styling */}
        <div className="md:pl-1">
          <div className="overflow-x-auto border border-slate-200 bg-white shadow-sm max-h-[550px]">
            <table className="min-w-full table-auto border-collapse text-sm">
              <thead>
                <tr className="sticky top-0 z-10 bg-[#00304b] text-white" style={{ fontFamily: "saans-bold" }}>
                  <th className="px-4 py-3 text-left font-semibold">Program</th>
                  <th className="px-4 py-3 text-left font-semibold">Duration</th>
                  <th className="px-4 py-3 text-left font-semibold">Eligibility (Min.)</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr
                    key={i}
                    className={`transition-colors ${i % 2 === 0 ? "bg-white" : "bg-slate-50/70"} hover:bg-sky-50`}
                    style={{ fontFamily: "saans-regular" }}
                  >
                    <td className="px-4 py-3 align-top border-t border-slate-200">
                      <span className="font-medium text-slate-800">{row.program}</span>
                    </td>
                    <td className="px-4 py-3 align-top border-t border-slate-200 text-slate-700">
                      {row.duration}
                    </td>
                    <td className="px-4 py-3 align-top border-t border-slate-200 text-slate-700">
                      {row.eligibility}
                    </td>
                  </tr>
                ))}

                {rows.length === 0 && (
                  <tr>
                    <td
                      colSpan={3}
                      className="px-4 py-5 text-center text-slate-500 border-t border-slate-200"
                    >
                      No programs configured for this category.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
